import React from "react";
import { useSelector } from "react-redux";

import { ReactComponent as SelectedIcon } from "src/images/selected.svg";
import { RootState } from "src/redux/reducers";
import { DropdownMenuItem } from "../../components/Dropdown/Dropdown";
import { SkeletonRect } from "../../components/Skeleton/Skeleton";

export default function WorkspacesList() {
  const { workspacesList, activeWorkspaceUuid, isWorkspacesListLoading } =
    useSelector((state: RootState) => state.mainReducer);

  const getWorkspaceDisplayGroupOrderByName = (wsName: string) => {
    if (wsName?.toLowerCase().includes(" (demo)")) {
      return 1;
    }
    if (wsName?.toLowerCase().includes(" (trial)")) {
      return 2;
    }
    if (wsName?.toLowerCase().includes(" (resets on")) {
      return 3;
    }

    return 0;
  };

  const sortedWorkspacesList = workspacesList.toSorted((a, b) => {
    if (
      getWorkspaceDisplayGroupOrderByName(a?.name) ===
      getWorkspaceDisplayGroupOrderByName(b?.name)
    ) {
      if (a?.name?.toLowerCase() < b?.name?.toLowerCase()) return -1;
      if (a?.name?.toLowerCase() > b?.name?.toLowerCase()) return 1;
    }

    return (
      getWorkspaceDisplayGroupOrderByName(a?.name) -
      getWorkspaceDisplayGroupOrderByName(b?.name)
    );
  });

  const renderContent = () => {
    if (isWorkspacesListLoading) {
      return Array.from({ length: 5 }).map((_, i) => (
        <div className="dropdown__menu-item" key={i}>
          <SkeletonRect height={20} width={300} />
        </div>
      ));
    } else {
      return sortedWorkspacesList.map((workspace) => (
        <DropdownMenuItem
          key={workspace.uuid}
          dark={workspace.uuid === activeWorkspaceUuid}
          aria-disabled={workspace.uuid === activeWorkspaceUuid}
          onClick={() => {
            if (workspace.uuid !== activeWorkspaceUuid) {
              window.open(workspace.wsUrl, "_blank");
            }
          }}
        >
          {workspace.name}
          <span
            style={{
              marginLeft: "auto",
              display: "flex",
              gap: 8,
              color: "#666",
              filter: "grayscale(1)",
            }}
          >
            {workspace.workspaceFlags?.internal && (
              <span title="Internal">🏠</span>
            )}
            {workspace.workspaceFlags?.test && <span title="Test">🚧</span>}
            {workspace.workspaceFlags?.sandbox && (
              <span title="Sandbox">🎬</span>
            )}
            {workspace.openMeterManaged === true && (
              <span
                title={
                  workspace.openMeterPlan
                    ? `OpenMeter: Active — ${workspace.openMeterPlan}`
                    : "OpenMeter: Expired — no plan"
                }
              >
                <svg
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  style={{
                    display: "block",
                    width: 14,
                    height: 14,
                    color: "#666",
                  }}
                >
                  <path
                    d="M12 2.5l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3.1-5.8 3.1 1.1-6.5-4.7-4.6 6.5-.9z"
                    style={{
                      fill: workspace.openMeterPlan ? "currentColor" : "none",
                    }}
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </span>
          <span style={{ width: 20, flexShrink: 0 }}>
            {workspace.uuid === activeWorkspaceUuid && (
              <SelectedIcon
                className="dropdown__menu-item-tick"
                style={{
                  marginLeft: 0,
                  marginRight: 0,
                }}
              />
            )}
          </span>
        </DropdownMenuItem>
      ));
    }
  };

  return <div className="dropdown__menu-list-wrapper">{renderContent()}</div>;
}
